import * as React from "react";

interface SvgComponentProps {
	[key: string]: any;
}

const VectorIcon: React.FC<SvgComponentProps> = (props) => (
	<svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={32}
    fill="none"
    {...props}
  >
    <path
      stroke= "currentColor"
	//   "#323232"
      strokeWidth={2}
      d="m22.612 9.17-.331-.141.32-.132.364-.15.164-.357.123-.267.123.267.164.357.363.15.32.132-.33.14-.365.155-.16.363-.115.264-.116-.264-.16-.363-.364-.155Zm-.006 13.935-.298-.124.298-.125.372-.155.16-.37.114-.262.114.262.16.37.372.155.298.125-.298.124-.36.15-.163.355-.123.267-.123-.267-.163-.354-.36-.15Zm-11.19-5.445-.16-.334-.34-.148L8.218 16l2.698-1.178.338-.147.161-.333 1.314-2.706 1.326 2.71.16.328.335.147L17.231 16l-2.68 1.179-.335.147-.161.329-1.33 2.718-1.309-2.713Z"
    />
  </svg>
);
export default VectorIcon;
